interface SeatWithSegment {
	segmentId?: string;
	number?: string;
}

/** Возвращает места пассажира на указанном сегменте. */
const getSeatsOnSegment = (seats: SeatWithSegment[], segmentId: string) => {
	return seats.filter(seat => seat.segmentId === segmentId && !!seat.number);
};

/** Проверяет, выбрано ли у пассажира более одного места на сегменте (пара экстрасита). */
export const isDoubleSeatsOnSegment = (seats: SeatWithSegment[], segmentId: string): boolean => {
	return getSeatsOnSegment(seats, segmentId).length > 1;
};

/**
 * Возвращает номера мест для удаления.
 * Для пары экстрасита — все места на сегменте, для одиночного места — только кликнутый номер.
 */
export const getSeatNumbersToRemove = (
	seats: SeatWithSegment[],
	segmentId: string,
	clickedSeatNumber: string
): string[] => {
	if (isDoubleSeatsOnSegment(seats, segmentId)) {
		return getSeatsOnSegment(seats, segmentId).map(seat => seat.number);
	}

	return [clickedSeatNumber];
};
